'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _HighlightTitleForPublisherPackage = require('./HighlightTitleForPublisherPackage.scss');var _HighlightTitleForPublisherPackage2 = _interopRequireDefault(_HighlightTitleForPublisherPackage);
var _components = require('../../components');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var HighlightTitleForPublisherPackage = function HighlightTitleForPublisherPackage(props) {var
  haveHighlight = props.haveHighlight,haveAutojump = props.haveAutojump,haveTopPromotion = props.haveTopPromotion;

  if (!haveHighlight && !haveAutojump && !haveTopPromotion) {return null;}

  var autoJump = haveAutojump &&
  _react2.default.createElement('span', { className: 'icon icon-auto-jump-active' },
    _react2.default.createElement('i', { className: 'path1' }),
    _react2.default.createElement('i', { className: 'path2' }),
    _react2.default.createElement('i', { className: 'path3' }));


  var highlight = haveHighlight &&
  _react2.default.createElement('span', { className: 'icon icon-promoted-active' },
    _react2.default.createElement('i', { className: 'path1' }),
    _react2.default.createElement('i', { className: 'path2' }),
    _react2.default.createElement('i', { className: 'path3' }));


  var topPromotion = haveTopPromotion &&
  _react2.default.createElement(_components.OMLabelTop, {
    label: 'TOP',
    title: 'TOP' });


  var separator = haveHighlight && _react2.default.createElement('span', null, '\xA0+\xA0');

  return (
    _react2.default.createElement('div', { className: _HighlightTitleForPublisherPackage2.default.wrapper },
      topPromotion,
      autoJump,
      separator,
      highlight));


};

HighlightTitleForPublisherPackage.propTypes = {
  haveHighlight: _propTypes2.default.bool,
  haveTopPromotion: _propTypes2.default.bool,
  haveAutojump: _propTypes2.default.bool,
  topPromotionLabel: _propTypes2.default.string };exports.default =


HighlightTitleForPublisherPackage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HighlightTitleForPublisherPackage/HighlightTitleForPublisherPackage.js
// module id = 2681
// module chunks = 0